document.addEventListener("DOMContentLoaded", () => {


document.querySelectorAll(".information-drawers").forEach(section => {


const drawer = section.querySelector(".information-drawer");
const content = section.querySelector(".drawer-content");


section.querySelectorAll(".information-row").forEach(row => {


row.addEventListener("click", () => {


const id = row.dataset.drawerId;


const hiddenContent = section.querySelector(
`[data-content-id="${id}"]`
);


content.innerHTML = hiddenContent.innerHTML;


drawer.classList.add("active");


});


});


section.querySelector(".drawer-close")
.addEventListener("click",()=>{

drawer.classList.remove("active");

});


section.querySelector(".drawer-overlay")
.addEventListener("click",()=>{

drawer.classList.remove("active");

});


});


});